
(function organizationProviderDefinition() {

    angular.module('CPPConfig', [])
        .provider('initialConfig', function () {

            var configuracion = window.ConfigurationManager.getConfig();

            /*
             * Retorna todos los valores configurados.
             */
            this.getConfig = function () {
                return configuracion;
            };

            this.$get = function () {
                return configuracion;
            };
        });

})();